var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 48,
    viewBox: "0 0 31 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.72 21.616C30.72 21.616 28.4 21.856 28.256 21.888L28.24 21.872C28.176 21.776 28.096 21.696 28 21.616L28.416 19.056L27.392 18.672C25.616 18 23.504 17.504 21.232 17.232L21.056 16.832L19.456 13.248L20.816 13.12L18.096 9.248L17.04 7.584C17.04 7.584 16.848 7.504 16.72 7.456C16.752 7.328 17.296 4.224 14.72 2.704C14.176 2.384 13.632 2.176 13.136 2.032C13.136 2.032 12.832 1.936 12.272 1.856C11.2 1.712 9.87202 1.888 9.28002 2.016C8.86402 1.712 8.11202 0.496002 8.11202 0.496002C8.11202 0.496002 7.90402 3.152 9.53602 4.656C8.84802 4.368 8.40002 4.032 7.90402 3.632C7.52002 3.36 7.12002 3.04 6.59202 2.752C6.09602 2.48 5.58401 2.336 5.07201 2.336C3.93601 2.336 2.84801 3.296 2.84801 3.296C2.84801 3.296 4.30401 3.44 5.04001 3.904C4.35201 3.92 4.25601 4.512 4.25601 4.512L4.67201 4.752C5.90402 5.52 4.91201 5.696 4.54401 5.536L3.47201 4.96C3.47201 4.96 4.01601 6.96 5.34402 7.088L5.04001 7.376C5.04001 7.376 7.34402 7.776 8.06402 8.496C8.57602 8.992 8.84802 9.488 8.48002 9.664C8.20802 9.792 7.84002 9.52 7.58402 9.216C7.29602 8.864 7.07202 8.176 7.07202 8.176C6.64002 9.024 6.97601 9.936 6.97601 9.936C7.15201 10.48 7.56802 11.232 8.56002 11.632C9.37602 11.968 9.64802 12.192 9.84002 12.384C10.672 13.28 11.12 14.416 11.12 14.416L10.096 17.168L9.96802 17.552C7.72802 17.968 5.66401 18.576 3.90401 19.36L2.57601 19.968L3.34401 22.368C2.46401 22.912 1.47201 23.76 1.20001 24.912C1.02401 25.616 1.15201 26.304 1.53601 26.912C1.88801 27.44 2.40001 27.84 3.00801 28.032L2.57601 30.352C1.52001 31.056 0.848014 31.888 0.624014 32.752C0.448014 33.44 0.576014 34.128 0.960014 34.736C1.29601 35.248 1.77601 35.616 2.35201 35.824L2.00001 37.728L2.06401 37.856C2.08001 37.888 2.48001 38.688 3.20001 39.472C3.95201 40.304 5.13601 40.944 5.76001 41.264C5.66401 41.504 5.52002 41.888 5.58402 43.968L5.66402 47.296L8.16002 45.056C8.17602 45.056 9.00801 44.304 10.352 43.312C10.784 43.776 11.664 44.688 12.608 45.44C13.936 46.496 15.44 47.184 15.616 47.264C16.256 47.552 16.256 47.552 16.352 47.552H16.496L16.608 47.472C17.536 46.784 19.536 44.976 19.632 44.896L21.504 43.136L22.64 41.984L23.888 40.64L25.216 39.104L26.272 37.728L25.472 37.536L26.8 37.2L26.72 36.448L27.088 36.512L27.68 35.632C28.032 35.12 28.848 33.712 29.2 32.752L29.424 32.16L29.312 31.84L29.696 30.96C30.24 29.744 30.608 27.904 30.016 26.432L29.664 25.52C30.128 24.976 30.256 24.256 30.368 23.648L30.72 21.616ZM15.584 16.976C14.576 17.008 13.568 17.072 12.592 17.184C13.504 16.736 14.128 16.16 14.464 15.792C15.216 16.336 16.032 16.704 16.8 16.96C16.784 16.96 16.768 16.96 16.752 16.96C16.384 16.96 15.984 16.96 15.584 16.976Z",
    fill: "url(#paint0_linear_876_11451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38401 41.072C6.24001 41.232 6.19201 41.344 6.17601 41.392C6.09601 41.568 5.96801 41.888 6.01601 43.936L6.08001 46.352L7.87201 44.736C7.88801 44.72 8.86401 43.856 10.4 42.736C10.592 42.96 11.664 44.144 12.864 45.088C14.176 46.144 15.712 46.816 15.776 46.848L16.352 47.104C17.264 46.416 19.344 44.56 19.344 44.56L18.192 43.936L20.064 43.888L20.704 43.296L19.52 42.864L21.312 42.704L21.984 42.016L20.4 41.6L22.448 41.552L23.104 40.848L21.328 40.368L23.568 40.336L24.416 39.36L21.984 38.88H24.816L25.52 37.968L23.712 37.52L26.32 36.864L26.224 35.92L26.88 36.032L27.312 35.376C27.648 34.896 28.448 33.504 28.784 32.592L28.944 32.16L28.752 31.744C28.704 31.632 28.64 31.52 28.592 31.424L29.008 31.408L29.296 30.768C29.792 29.632 30.144 27.92 29.616 26.56L29.168 25.408C29.696 24.944 29.824 24.224 29.952 23.568L30.224 22.096L28.736 22.256C28.512 22.272 28.288 22.32 28.08 22.352C28.032 22.272 27.984 22.192 27.936 22.128C27.84 22 27.712 21.888 27.568 21.808L27.968 19.344L27.264 19.072C24.4 17.984 20.672 17.392 16.784 17.392C16.4 17.392 16 17.392 15.616 17.408C11.28 17.536 7.20001 18.368 4.09601 19.76L3.12001 20.208L3.888 22.576C3.872 22.576 3.87201 22.592 3.85601 22.592C2.992 23.088 1.92 23.904 1.648 25.024C1.504 25.616 1.6 26.192 1.936 26.688C2.304 27.248 2.86401 27.6 3.55201 27.712L3.008 30.592C2.224 31.088 1.328 31.84 1.088 32.832C0.944005 33.408 1.04 33.984 1.36 34.48C1.696 35.008 2.24 35.36 2.88001 35.488L2.48 37.632C2.48 37.632 2.84801 38.4 3.55201 39.152C4.54401 40.288 6.38401 41.072 6.38401 41.072Z",
    fill: "#3A225D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40002 6.448C7.53602 5.872 8.16002 5.616 8.25602 5.616C8.35202 5.616 7.04002 5.36 6.38402 4.784C5.68002 4.144 4.92802 4.304 4.88002 4.384C4.88002 4.384 6.01602 5.024 5.71202 5.648C5.32802 6.416 4.35202 5.904 4.35202 5.904C4.35202 5.904 4.92802 7.184 6.40002 6.448Z",
    fill: "#3A225D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.096 5.312C8.20803 4.768 7.76003 3.888 6.38403 3.12C5.00803 2.352 3.95203 3.056 3.95203 3.056C5.20003 3.264 5.82403 3.968 7.02403 4.768C8.24003 5.568 10.096 5.312 10.096 5.312Z",
    fill: "#3A225D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.912 9.48799C10.912 9.48799 11.28 8.79999 11.904 8.36799C11.904 8.36799 11.84 8.31999 11.744 8.25599C11.424 8.04799 10.688 7.58399 9.87203 7.34399C9.87203 7.34399 10.992 7.19999 12.608 7.67999C12.656 7.69599 12.688 7.69599 12.736 7.71199C12.736 7.71199 13.072 7.42399 14.384 7.31199C15.312 7.23199 16.08 7.47199 16.08 7.47199C16.08 7.47199 16.064 7.42399 16.016 7.34399C15.776 6.86399 14.704 5.10399 12.144 5.23199C12.144 5.23199 13.008 5.48799 13.296 6.41599C13.296 6.41599 12.144 5.59999 9.64803 5.74399C7.15203 5.87199 5.84003 7.15199 5.84003 7.15199C5.84003 7.15199 7.10403 7.43999 8.08003 7.77599C9.24803 8.17599 10.496 9.16799 10.768 9.39199C10.8 9.42399 10.832 9.43999 10.832 9.43999L10.912 9.48799Z",
    fill: "#3A225D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.944 5.472C10.944 5.472 11.376 4.976 12.656 4.96C13.472 4.96 14.4 5.376 14.4 5.376C14.304 4.336 13.632 3.744 13.632 3.744C15.216 4.128 15.328 5.984 15.344 6C15.888 6.4 16.304 7.408 16.304 7.408C16.304 7.408 16.864 4.48 14.512 3.104C12.48 1.92 10.576 2.304 10.576 2.304C10.576 2.304 11.44 2.432 12.064 3.008C12.688 3.568 12.48 4.512 11.312 4.208C10.144 3.904 8.65601 1.952 8.65601 1.952C8.83201 3.808 10.944 5.472 10.944 5.472Z",
    fill: "#3A225D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.592 9.79201C10.592 9.77601 10.608 9.77601 10.608 9.76001C10.624 9.72801 10.64 9.69601 10.656 9.68001C10.64 9.66401 9.52003 8.52801 8.30403 8.20801C8.30403 8.20801 9.28003 9.08801 9.07203 9.68001C8.76803 10.512 7.48803 9.87201 7.28003 9.29601C7.28003 9.29601 7.34403 10.672 8.73603 11.264C9.47203 11.568 9.90403 11.856 10.096 12.08C10.192 12.192 10.224 12.272 10.224 12.272C10.224 12.272 10.112 10.816 10.592 9.79201Z",
    fill: "#3A225D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 12.032C10.96 10.64 11.408 9.55201 12.256 8.86401C13.424 7.93601 14.72 7.85601 15.616 7.95201C16.208 8.01601 16.688 8.16001 16.976 8.27201L16.752 7.92001C16.752 7.92001 14.304 6.88001 12.24 8.36801C10.768 9.42401 10.4 11.36 10.768 12.72L11.056 13.216C11.008 12.912 10.96 12.496 10.96 12.032Z",
    fill: "#3A225D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.104 8.68801C16.864 8.59201 16.304 8.40001 15.6 8.32001C14.736 8.22401 13.472 8.30401 12.352 9.20001C11.328 10.016 11.12 11.312 11.12 12.256C11.12 12.912 11.216 13.504 11.296 13.84L11.568 14.304C11.568 14.304 12.672 13.728 13.264 12.496C14.304 10.272 15.52 9.76001 16.544 9.58401C17.28 9.45601 17.584 9.44001 17.584 9.44001L17.104 8.68801Z",
    fill: "#3A225D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.48 16.72C19.488 16.736 16.736 16.624 14.368 14.704C14.256 14.864 13.984 15.248 13.488 15.68C12.928 16.176 11.984 16.784 10.704 16.96L10.56 17.328C13.024 17.088 14.416 15.216 14.416 15.216C17.088 17.36 20.624 17.04 20.624 17.04L20.48 16.72Z",
    fill: "#3A225D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.384 11.872C18.384 11.872 18 12.448 17.12 12.304C16.24 12.144 16.016 11.312 16.016 11.312C16.048 11.312 17.312 11.216 17.488 11.2C18.704 11.088 19.088 12.88 19.088 12.88L20.048 12.8L17.872 9.696C15.616 9.696 14.512 10.736 13.536 12.608C12.736 14.16 11.504 14.64 11.504 14.64L10.752 16.672C13.104 16.32 14.272 14.448 14.288 14.416L14.336 14.352L14.4 14.4C16.688 16.288 19.392 16.448 20.416 16.432L18.384 11.872ZM15.856 10.736C15.856 10.736 17.28 10.608 17.44 10.608C17.664 10.624 17.984 10.704 18.08 10.928C18.08 10.928 17.888 10.8 17.504 10.816C17.2 10.832 15.952 10.928 15.952 10.928L15.856 10.736ZM19.856 16.224L18.128 12.336C18.128 12.336 18.224 12.304 18.336 12.192L20.128 16.256C20.128 16.24 19.984 16.24 19.856 16.224Z",
    fill: "#3A225D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.32 8.336C13.696 8.432 13.008 8.672 12.368 9.168L13.536 11.904C14.032 11.024 14.576 10.496 15.088 10.144L14.32 8.336Z",
    fill: "url(#paint1_linear_876_11451)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.704 14.64C15.664 15.36 16.688 15.792 17.6 16.048L15.216 10.448C14.608 10.88 14.144 11.504 13.696 12.288L14.704 14.64Z",
    fill: "url(#paint2_linear_876_11451)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.184 15.76C16.112 16.32 17.072 16.64 17.936 16.832L17.744 16.384C16.848 16.144 15.856 15.76 14.896 15.104L15.184 15.76Z",
    fill: "url(#paint3_linear_876_11451)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40002 20.64L6.60802 21.28L6.14402 21.424L5.96802 20.912L5.50402 21.056L5.68002 21.568L5.21602 21.712L4.80002 20.432L5.26402 20.288L5.44002 20.8L5.50402 20.784L5.76002 20.128L6.25602 19.968L5.98402 20.624L6.14402 20.576C6.25602 20.544 6.38402 20.56 6.40002 20.64ZM9.80802 20.352C9.82402 20.432 9.72802 20.512 9.60002 20.528L8.64002 20.736C8.51202 20.768 8.38402 20.736 8.36802 20.656L8.14402 19.6C8.12802 19.52 8.22402 19.44 8.35202 19.408L9.31202 19.2C9.44002 19.168 9.56802 19.2 9.58402 19.28L9.80802 20.352ZM9.31202 20.336L9.13602 19.536L8.65602 19.632L8.83202 20.432L9.31202 20.336ZM12.592 19.536L12.624 19.808L12.144 19.872L12.016 18.784L11.536 18.848L11.696 20.192L13.152 20.016L13.088 19.44L12.592 19.536ZM15.856 18.496L15.44 19.056H15.376L15.36 18.512L14.88 18.528L14.928 19.888L15.408 19.872L15.392 19.328L15.872 19.312L15.888 19.856L16.368 19.84L16.352 19.168C16.352 19.088 16.24 19.04 16.112 19.04H15.936L16.384 18.48L15.856 18.496ZM19.76 18.72L19.696 19.936L19.216 19.904L19.248 19.36L18.768 19.328L18.736 19.872L18.256 19.84L18.32 18.624C18.32 18.544 18.432 18.496 18.576 18.496L19.552 18.544C19.664 18.576 19.76 18.64 19.76 18.72ZM19.264 18.816L18.784 18.784L18.768 19.056L19.248 19.088L19.264 18.816ZM21.616 19.024L22.096 19.088L21.936 20.16L22.416 20.224L22.576 19.152L23.056 19.216L23.088 18.96L21.648 18.752L21.616 19.024ZM26.352 19.84L26.048 21.024L25.584 20.896L25.728 20.368L25.248 20.24L25.12 20.768L24.656 20.64L24.96 19.456C24.976 19.376 25.104 19.344 25.232 19.392L26.176 19.632C26.288 19.68 26.384 19.76 26.352 19.84ZM25.856 19.84L25.392 19.712L25.328 19.984L25.808 20.112L25.856 19.84Z",
    fill: "url(#paint4_linear_876_11451)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.728 22.096C22.88 21.024 19.52 20.576 15.84 20.72C13.6 20.8 11.408 21.072 9.47202 21.616L9.40802 21.984C11.392 21.52 13.536 21.2 15.824 21.152C19.728 21.056 22.848 21.568 25.664 22.384L25.728 22.096Z",
    fill: "url(#paint5_linear_876_11451)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34403 43.792C7.34403 43.792 7.29603 41.984 7.40803 41.696C7.52003 41.408 11.408 38.752 16.928 37.104C22.448 35.456 26.208 35.632 26.208 35.632C26.208 35.632 19.648 35.968 13.44 39.472C9.90403 41.488 7.34403 43.792 7.34403 43.792Z",
    fill: "url(#paint6_linear_876_11451)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.496 42.288C16.496 43.216 16.4 45.28 16.4 45.28C16.4 45.28 15.216 44.448 14.448 43.648C13.792 42.976 13.12 41.984 13.12 41.984C13.12 41.984 13.696 41.376 14.576 40.736C15.536 40.048 16.48 39.6 16.48 39.6C16.48 39.6 16.512 41.184 16.496 42.288ZM23.776 36.736C23.776 36.736 21.808 36.656 17.44 38.384C13.072 40.096 11.44 41.872 11.44 41.872C11.44 41.872 12.56 43.152 13.792 44.128C15.008 45.104 16.464 45.744 16.464 45.744C16.464 45.744 17.088 45.312 18.08 44.416C18.016 44.368 17.936 44.336 17.856 44.288C17.28 43.968 16.736 43.872 16.736 43.872C16.736 43.872 18.064 43.536 19.008 43.536L19.024 43.52C18.928 43.472 18.848 43.44 18.736 43.392C17.472 42.88 16.752 42.72 16.752 42.72C16.752 42.72 19.104 42.144 20.304 42.144C19.616 41.968 19.504 41.968 19.072 41.888C17.952 41.68 17.216 41.52 17.216 41.52C17.216 41.52 19.184 41.168 21.536 40.976C21.2 40.864 20.736 40.816 20.16 40.736C18.832 40.576 17.712 40.384 17.712 40.384C17.712 40.384 18.816 40.16 20.368 39.936C21.328 39.808 22.016 39.728 22.496 39.68C22.144 39.6 21.664 39.52 21.152 39.456C20.032 39.344 20.032 39.328 18.256 39.328C18.256 39.328 20.464 38.384 23.232 38.368C22.896 38.272 21.984 38.112 20.928 38.128C20.208 38.144 19.008 38.192 19.008 38.192C19.008 38.192 21.616 37.12 23.776 36.736Z",
    fill: "url(#paint7_linear_876_11451)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.544 25.456L12.4 26.048C12.608 25.92 13.232 25.632 13.792 25.424C14.128 25.312 14.528 25.488 14.432 25.936L13.792 28.96C13.344 29.12 12.576 29.424 12.208 29.6L12.912 26.544C12.624 26.64 12.368 26.752 12.208 26.832L11.632 29.312C11.472 29.12 10.72 27.968 10.56 27.616C10.8 26.384 10.608 26.512 10.608 26.512L10.672 26.256C11.168 26.128 12.112 25.712 12.544 25.456ZM8.89601 26.352C10.16 26.08 14.88 24.832 14.128 21.776C13.136 21.856 12.192 21.968 11.264 22.128C11.568 22.32 11.84 22.8 11.456 23.696C10.736 25.376 8.28801 25.568 7.80801 25.6L8.56001 21.824C7.66401 22.096 5.69601 22.8 4.60801 23.424C3.28001 24.192 2.54401 25.168 3.05601 25.952C3.47201 26.592 4.25601 26.528 4.52801 26.48L4.80001 25.168C4.70401 25.152 4.49601 25.072 4.56001 24.784C4.67201 24.304 5.61601 23.792 6.56001 23.376L5.29601 30.112C5.88801 29.84 6.59201 29.584 7.16801 29.44L7.52001 27.28C8.59201 27.552 9.32801 32.384 14.592 31.488C10.736 31.104 10.416 27.408 8.89601 26.352ZM16.8 24.688L17.008 23.808C17.232 22.976 16 23.408 15.552 23.728L15.248 25.008C15.6 24.816 16.544 24.432 16.8 24.688ZM14.784 25.952C14.784 25.952 14.912 26.352 14.736 27.12L14.192 29.728C14.608 29.392 15.344 29.072 15.824 28.896L16.56 25.712C16.672 25.264 16.272 25.104 15.984 25.168C15.584 25.264 15.04 25.568 14.864 25.68L14.784 25.952ZM22.752 25.152L23.28 22.912C23.392 22.464 22.928 22.288 22.72 22.368C22.688 22.384 22.672 22.384 22.64 22.4C22.16 22.592 21.744 22.832 21.568 22.944L21.504 23.216C21.504 23.216 21.632 23.616 21.456 24.384L20.08 30.256L21.68 29.712L22.528 26.048C22.72 25.968 22.96 25.872 23.232 25.776L22.368 29.472L23.872 28.944L24.736 25.216C24.848 24.768 24.4 24.608 24.128 24.672C23.904 24.72 23.44 24.864 22.752 25.152ZM22.752 25.152L23.28 22.912C23.392 22.464 22.928 22.288 22.72 22.368C22.688 22.384 22.672 22.384 22.64 22.4C22.16 22.592 21.744 22.832 21.568 22.944L21.504 23.216C21.504 23.216 21.632 23.616 21.456 24.384L20.08 30.256L21.68 29.712L22.528 26.048C22.72 25.968 22.96 25.872 23.232 25.776L22.368 29.472L23.872 28.944L24.736 25.216C24.848 24.768 24.4 24.608 24.128 24.672C23.904 24.72 23.44 24.864 22.752 25.152ZM11.856 31.952C11.552 31.904 11.248 31.856 10.976 31.792L10.672 33.072C11.6 32.544 12.096 32.656 12.192 32.88L12.304 32.4C12.368 32.208 12.272 32.016 11.856 31.952ZM10.208 34.144C10.208 34.144 10.384 34.224 10.16 35.312L9.95201 36.224C10.144 36.352 10.944 36.752 11.296 36.832L12.016 33.728C12.112 33.312 11.696 33.088 11.36 33.232C10.768 33.488 10.544 33.696 10.288 33.856L10.208 34.144ZM24.464 32.016L24.576 31.52L24.64 31.264L24.752 30.752C24.944 29.92 24.448 29.568 23.888 29.792C23.456 29.968 22.976 30.48 22.736 30.768L22.88 30.192C22.256 30.432 21.632 30.64 21.024 30.832L20.96 31.104C20.96 31.104 21.12 31.248 20.912 32.272L20.256 35.088C20.752 34.976 21.488 34.816 21.808 34.752L22.544 31.616C22.72 31.456 22.992 31.232 23.312 31.008L22.992 32.352C23.296 32.256 23.952 32.112 24.464 32.016ZM3.84001 37.328C4.00001 37.6 4.00001 37.6 4.14401 37.792L5.10401 32.576C4.97601 32.672 4.78401 32.784 4.65601 32.896L3.84001 37.328ZM11.184 38.672C8.08001 38.912 7.28001 36.72 6.48001 36.72L6.41601 37.056C7.15201 37.088 8.27201 39.296 11.184 38.672ZM24.528 28.688C24.8 28.608 25.008 28.784 25.088 28.88C26.048 28.368 27.296 27.472 28.064 26.864C27.392 27.104 26.592 27.264 26.352 27.296L26.96 24.72C27.2 24.688 27.584 24.672 28.016 24.656C28.752 24.608 28.848 24.352 29.056 23.248C28.416 23.312 27.792 23.488 27.216 23.632L27.328 23.136C27.44 22.688 27.088 22.48 26.768 22.576C26.384 22.688 25.76 23.024 25.552 23.152L25.488 23.408C25.488 23.408 25.664 23.504 25.536 24.144C25.44 24.176 25.376 24.24 25.2 24.32L24.992 25.248C25.168 25.184 25.28 25.136 25.392 25.104C25.248 25.68 24.688 28.016 24.528 28.688ZM20.528 31.792L20.096 33.648C19.648 33.536 18.592 33.616 18.048 33.808L17.84 34.736C18.816 34.4 19.856 34.176 20.064 34.192L19.488 35.264C19.088 35.36 17.024 35.984 16.656 36.096C16.576 35.952 16.448 35.744 16.128 35.744L16.704 33.392C16.88 32.624 16.736 32.256 16.736 32.256L16.8 31.968C17.504 31.92 18.544 31.52 19.68 31.2C20.48 31.008 20.64 31.312 20.528 31.792ZM19.136 32.064C18.912 32.112 18.512 32.272 18.4 32.304L18.208 33.136C18.4 33.056 18.688 32.96 18.944 32.896L19.136 32.064ZM28.464 30.208C28.128 30.224 27.472 30.544 27.12 30.832C27.424 31.136 27.664 31.536 27.936 32.112C27.632 32.928 26.896 34.224 26.608 34.64C25.264 34.272 23.136 34.56 22.64 34.64L22.976 33.184C23.104 33.152 23.616 32.976 24.128 32.96C24.256 32.816 25.216 31.84 25.392 31.648L25.104 31.392L25.328 30.384C25.456 29.792 25.184 29.616 25.184 29.616L25.216 29.344C26.08 28.912 27.936 27.696 28.768 26.864C29.136 27.776 28.96 29.104 28.464 30.208ZM25.84 31.952C25.296 32.496 25.088 32.72 24.88 32.96C25.632 32.928 26.24 33.392 26.4 33.136C26.608 32.752 26 32.128 25.84 31.952ZM27.568 28.992C27.28 29.232 27.184 29.296 26.992 29.424L26.768 30.4C27.2 30.112 27.632 29.856 27.856 29.792C27.952 29.44 27.728 29.04 27.568 28.992ZM7.80801 35.28C10.176 34.8 10.256 32.816 10.464 31.92C10 31.776 9.63201 31.584 9.34401 31.376C8.51201 30.736 8.04801 30.224 7.74401 29.728C6.88001 30 5.08801 30.688 4.01601 31.296C2.70401 32.048 2.00001 33.008 2.49601 33.776C2.91201 34.416 3.68001 34.336 3.93601 34.288L4.19201 33.008C4.09601 32.992 3.88801 32.912 3.95201 32.64C4.06401 32.176 5.60001 31.2 6.88001 30.8C7.15201 31.232 7.64801 31.856 8.16001 32.272C8.30401 32.4 8.48001 32.512 8.65601 32.624C8.56001 33.056 8.44801 33.456 8.25601 33.792C7.93601 34.384 7.40801 34.96 6.56001 35.04L7.21601 31.552C6.62401 31.808 6.06401 32.08 5.55201 32.384L4.46401 38.08C4.92801 38.656 5.29601 39.008 5.77601 39.248L6.32001 36.16C7.55201 36.256 8.46401 38.976 12.432 38.24C13.376 38.064 14.24 37.472 14.944 36.864C14.592 37.04 14.064 37.216 13.232 37.344C9.80801 37.952 8.46401 35.264 7.80801 35.28ZM4.30401 30.592C4.46401 30.512 4.64001 30.432 4.80001 30.352L5.95201 24.24C5.77601 24.352 5.60001 24.48 5.42401 24.608L4.30401 30.592ZM8.20801 25.184C10.72 24.912 11.728 23.28 11.024 22.416C11.392 22.88 10.784 24.48 8.27201 24.864L8.20801 25.184ZM11.328 31.52C9.02401 30.784 8.35201 28.496 7.63201 27.808L7.55201 28.256C8.06401 28.704 8.92801 31.056 11.328 31.52ZM7.37601 31.968C7.47201 32.352 7.87201 32.832 7.95201 32.928C7.82401 33.824 7.36001 34.304 6.84801 34.608L6.80001 34.864C7.47201 34.624 7.92001 34.08 8.12801 33.408C8.17601 33.248 8.22401 33.072 8.27201 32.896C7.98401 32.624 7.56801 32.208 7.37601 31.968ZM20.784 24.976L19.68 29.632C19.168 29.936 19.024 30.512 18.992 30.656C15.6 31.712 13.488 30.912 12.416 30.032C12.72 29.856 13.232 29.632 13.68 29.488L13.552 30.08C14.256 30.432 16.816 30.64 18.32 29.488L18.576 28.528C18.16 28.64 17.664 28.8 17.504 28.864C17.328 28.608 16.976 28.56 16.416 28.752L16.8 27.104C16.976 26.336 16.848 25.936 16.848 25.936L16.912 25.664C18.608 24.704 19.712 24.448 20.176 24.384C20.496 24.32 20.912 24.48 20.784 24.976ZM19.312 25.392C19.04 25.472 18.8 25.568 18.608 25.664L18.08 27.92C18.288 27.856 18.608 27.76 18.768 27.728L19.312 25.392ZM17.024 29.824L15.584 35.968C15.392 36.064 15.136 36.384 15.008 36.64C14.576 36.736 13.856 36.944 13.536 37.072C13.296 36.8 12.448 36.208 11.968 36.112L12.352 34.48C12.576 33.44 12.4 33.296 12.4 33.296L12.464 33.008C12.976 32.752 13.888 32.4 14.272 32.352C14.416 32.464 14.576 32.608 14.752 32.784L15.088 31.28C15.328 30.24 15.136 30.112 15.136 30.112L15.2 29.808C15.584 29.6 16.032 29.408 16.464 29.28C16.672 29.232 17.12 29.376 17.024 29.824ZM14.592 33.632C14.4 33.44 14.176 33.232 14.016 33.12L13.456 35.456C13.52 35.488 13.936 35.664 14.08 35.744L14.592 33.632Z",
    fill: "url(#paint8_linear_876_11451)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95201 6.416C8.51201 6.24 9.10401 6.112 9.69601 6.08C10.288 6.032 10.896 6.064 11.472 6.176C12.064 6.288 12.704 6.432 13.248 6.688C12.72 6.4 12.144 6.192 11.552 6.064C10.96 5.936 10.352 5.888 9.74401 5.92C9.13601 5.952 8.54401 6.08 7.96801 6.256C7.39201 6.432 6.83201 6.688 6.32001 7.008L6.20801 7.088L6.35201 7.104C6.76801 7.168 7.18401 7.264 7.58401 7.376C7.98401 7.488 8.38401 7.616 8.78401 7.776C9.16801 7.936 9.76001 8.24 9.76001 8.24C9.76001 8.24 9.45601 8 8.81601 7.696C8.43201 7.52 8.03201 7.392 7.61601 7.28C7.24801 7.184 6.88001 7.104 6.51201 7.024C6.70401 6.912 6.88001 6.816 7.10401 6.72C7.39201 6.624 7.66401 6.512 7.95201 6.416Z",
    fill: "#F2BF27"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59201 3.024C5.02401 3.088 5.45601 3.264 5.82401 3.488C6.01601 3.6 6.19201 3.728 6.35201 3.856C6.43201 3.92 6.51201 4 6.59201 4.08C6.67201 4.16 6.75201 4.224 6.83201 4.288C6.99201 4.432 7.15201 4.56 7.34401 4.672C7.52001 4.784 7.71201 4.864 7.92001 4.928C8.12801 4.992 8.33601 5.04 8.54401 5.088C8.75201 5.136 8.94401 5.152 9.16801 5.184C8.96001 5.168 8.73601 5.152 8.52801 5.12C8.32001 5.088 8.09601 5.056 7.88801 4.992C7.68001 4.928 7.47201 4.848 7.28001 4.736C7.10401 4.64 6.92801 4.512 6.75201 4.352C6.67201 4.288 6.59201 4.208 6.51201 4.128C6.43201 4.048 6.35201 3.984 6.28801 3.904C6.12801 3.76 5.95201 3.632 5.77601 3.52C5.60001 3.408 5.40801 3.312 5.21601 3.216C4.99201 3.152 4.80001 3.072 4.59201 3.024Z",
    fill: "#F2BF27"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.832 5.408C13.12 5.424 13.392 5.504 13.664 5.6C13.936 5.696 14.192 5.824 14.432 5.968C14.672 6.11201 14.896 6.304 15.104 6.49601C15.312 6.68801 15.488 6.91201 15.648 7.15201C15.456 6.94401 15.264 6.73601 15.04 6.56001C14.832 6.38401 14.608 6.20801 14.368 6.06401C14.128 5.92001 13.888 5.79201 13.616 5.68C13.376 5.568 13.104 5.472 12.832 5.408Z",
    fill: "#F2BF27"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.552 2.464C12.128 2.48 12.704 2.592 13.248 2.768C13.792 2.944 14.32 3.216 14.768 3.6C14.992 3.792 15.2 4 15.376 4.224C15.552 4.464 15.696 4.704 15.808 4.976C15.92 5.248 16 5.52 16.048 5.808C16.096 6.096 16.128 6.384 16.112 6.672C16.096 6.384 16.016 6.192 15.952 5.904C15.888 5.632 15.792 5.36 15.68 5.088C15.44 4.576 15.088 4.112 14.64 3.76C14.208 3.392 13.696 3.136 13.168 2.928C12.896 2.832 12.624 2.752 12.352 2.688C12.096 2.624 11.856 2.576 11.552 2.464Z",
    fill: "#F2BF27"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.592 3.776C12.608 3.984 12.496 4.22399 12.336 4.36799C12.176 4.51199 11.968 4.57599 11.76 4.60799C11.552 4.62399 11.344 4.608 11.152 4.56C10.96 4.512 10.768 4.432 10.576 4.336C10.208 4.144 9.88801 3.888 9.61601 3.6C9.32801 3.312 9.12001 2.944 8.92801 2.592C9.16801 2.912 9.42401 3.216 9.71201 3.504C10 3.776 10.32 4.01599 10.672 4.20799C10.848 4.30399 11.024 4.384 11.216 4.432C11.408 4.48 11.6 4.512 11.792 4.496C11.984 4.48 12.176 4.432 12.336 4.304C12.496 4.176 12.576 3.984 12.592 3.776Z",
    fill: "#F2BF27"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26401 4.464C5.85601 4.496 6.19201 4.864 6.41601 5.152C6.78401 5.632 7.39201 5.68 7.61601 5.648C7.10401 5.712 6.60801 5.632 6.36801 5.328C6.08001 4.928 5.80801 4.64 5.26401 4.464Z",
    fill: "#F2BF27"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86401 6.23999C5.47201 6.31999 5.77601 5.92 5.82401 5.84C5.80801 5.936 5.72801 6.11199 5.64801 6.19199C5.53601 6.31999 5.40801 6.36799 5.18401 6.35199C5.05601 6.33599 4.96001 6.28799 4.86401 6.23999Z",
    fill: "#F2BF27"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.672 8.496C8.848 8.56 9.008 8.64 9.168 8.736C9.328 8.832 9.472 8.928 9.632 9.024C9.776 9.136 9.92 9.248 10.048 9.376C10.176 9.504 10.304 9.648 10.384 9.808C10.256 9.68 10.128 9.568 9.984 9.456C9.84 9.344 9.696 9.232 9.552 9.136C9.264 8.912 8.96 8.704 8.672 8.496Z",
    fill: "#F2BF27"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69601 9.968C7.82401 10.112 7.98401 10.224 8.16001 10.304C8.33601 10.384 8.51202 10.4 8.70402 10.384C8.88002 10.368 9.04002 10.272 9.13602 10.128C9.23202 9.968 9.28002 9.776 9.28002 9.584C9.31202 9.776 9.29602 9.984 9.21602 10.176C9.16802 10.272 9.10402 10.352 9.00802 10.416C8.91202 10.48 8.81602 10.512 8.70402 10.512C8.49602 10.528 8.28802 10.496 8.11201 10.4C7.93601 10.288 7.79201 10.144 7.69601 9.968Z",
    fill: "#F2BF27"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.048 42.112C15.04 39.488 18.72 38.064 18.72 38.064C13.968 39.664 11.776 41.84 11.776 41.84L12.048 42.112Z",
    fill: "#3A225D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.728 28.784L24.56 25.216C24.576 25.12 24.576 25.04 24.528 24.976C24.464 24.896 24.336 24.848 24.256 24.848C24.352 24.944 24.4 25.072 24.352 25.264L23.52 28.848L23.728 28.784Z",
    fill: "#3A225D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.112 32.352C12.144 32.224 12.048 32.192 11.936 32.176L11.856 32.512C11.968 32.496 12.016 32.528 12.048 32.56L12.112 32.352Z",
    fill: "#3A225D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.576 29.504L26.352 30.512C26.432 30.48 26.496 30.416 26.576 30.384L26.816 29.376L26.576 29.504Z",
    fill: "#3A225D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95201 33.152C3.712 33.04 3.696 32.816 3.744 32.64C3.84 32.256 4.35201 31.824 5.32801 31.36C4.46401 31.744 3.664 32.176 3.536 32.672C3.456 32.976 3.552 33.28 3.92 33.36L3.95201 33.152Z",
    fill: "#3A225D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.072 35.2C19.152 35.184 19.296 35.136 19.328 35.136C19.44 34.864 19.6 34.624 19.696 34.432C19.632 34.448 19.584 34.448 19.504 34.464C19.36 34.672 19.2 34.944 19.072 35.2Z",
    fill: "#3A225D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.808 33.264C17.872 33.232 17.936 33.216 18.016 33.184L18.208 32.368C18.144 32.384 18.08 32.4 18 32.416L17.808 33.264Z",
    fill: "#3A225D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.08 31.328C20.048 31.328 20.032 31.328 20.032 31.328H20.016C20.128 31.408 20.208 31.552 20.16 31.744L19.792 33.36C19.856 33.36 19.92 33.376 19.984 33.376L20.4 31.632C20.416 31.552 20.416 31.488 20.368 31.424C20.288 31.376 20.16 31.328 20.08 31.328Z",
    fill: "#3A225D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.352 26.016C22.272 26.048 22.192 26.08 22.128 26.112L21.312 29.6L21.536 29.52L22.352 26.016Z",
    fill: "#3A225D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.368 25.728C16.432 25.424 16.16 25.312 16.048 25.36C16.144 25.424 16.192 25.584 16.144 25.776L15.456 28.752C15.52 28.72 15.6 28.704 15.68 28.688L16.368 25.728Z",
    fill: "#3A225D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.424 34.896C17.488 34.88 17.552 34.848 17.632 34.816L17.856 33.84C17.792 33.856 17.712 33.872 17.648 33.888L17.424 34.896Z",
    fill: "#3A225D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 22.576C22.864 22.672 22.912 22.8 22.88 22.976L22.352 25.232C22.432 25.2 22.512 25.168 22.576 25.136L23.104 22.96C23.12 22.864 23.12 22.784 23.056 22.72C22.976 22.608 22.864 22.576 22.8 22.576Z",
    fill: "#3A225D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.832 23.76C16.88 23.536 16.752 23.504 16.672 23.52L16.464 24.416C16.544 24.4 16.624 24.416 16.672 24.432L16.832 23.76Z",
    fill: "#3A225D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.112 31.872C24.176 31.856 24.256 31.84 24.32 31.84L24.56 30.768C24.624 30.496 24.624 29.872 24.096 29.952C24.4 30.016 24.448 30.368 24.336 30.864L24.224 31.376L24.112 31.872Z",
    fill: "#3A225D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.456 34.64C21.504 34.624 21.584 34.608 21.664 34.592L22.32 31.76C22.208 31.856 22.112 31.936 22.048 32L21.456 34.64Z",
    fill: "#3A225D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.32 30.896C22.4 30.8 22.496 30.688 22.592 30.592L22.608 30.512C22.544 30.544 22.464 30.56 22.4 30.592L22.32 30.896Z",
    fill: "#3A225D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.032 26.8C11.952 26.832 11.872 26.88 11.808 26.912L11.408 28.464C11.456 28.528 11.504 28.608 11.552 28.672L12.032 26.8Z",
    fill: "#3A225D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32002 22.112C8.24002 22.128 8.17602 22.16 8.09602 22.192L7.40802 25.664C7.47202 25.664 7.53602 25.648 7.61602 25.648L8.32002 22.112Z",
    fill: "#3A225D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15201 34.432C9.84001 33.904 10 32.912 10.208 32.048C10.16 32.032 10.064 32 10.016 31.968C9.82401 32.816 9.61601 33.968 9.15201 34.432Z",
    fill: "#3A225D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.272 25.824C12.192 25.856 12.112 25.888 12.048 25.92L11.984 26.208C12.032 26.176 12.144 26.144 12.208 26.112L12.272 25.824Z",
    fill: "#3A225D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M9.632 31.792C8.928 31.424 7.968 30.48 7.632 29.936C7.584 29.952 7.488 29.984 7.44 30C7.728 30.464 8.64 31.424 9.632 31.792Z",
    fill: "#3A225D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56002 25.328C4.32002 25.216 4.30402 24.976 4.35202 24.8C4.44802 24.4 4.97602 23.968 5.96802 23.504C5.08802 23.904 4.27202 24.336 4.12802 24.848C4.04802 25.168 4.14402 25.472 4.51202 25.552L4.56002 25.328Z",
    fill: "#3A225D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.504 33.408C11.472 33.408 11.44 33.408 11.424 33.424C11.552 33.52 11.648 33.68 11.6 33.872L11.024 36.352C11.072 36.384 11.2 36.416 11.2 36.416L11.808 33.744C11.824 33.664 11.808 33.584 11.76 33.52C11.712 33.456 11.6 33.408 11.504 33.408Z",
    fill: "#3A225D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5.504 38.784C5.552 38.832 5.616 38.864 5.648 38.896L6.144 36.176C6.096 36.176 6.032 36.176 5.984 36.192L5.504 38.784Z",
    fill: "#3A225D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10399 27.168L6.73599 29.376C6.81599 29.36 6.86399 29.344 6.94399 29.312L7.29599 27.2C7.24799 27.184 7.18399 27.168 7.10399 27.168Z",
    fill: "#3A225D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17599 35.168C6.23999 35.168 6.288 35.152 6.352 35.152L6.976 31.84C6.912 31.872 6.848 31.904 6.784 31.936L6.17599 35.168Z",
    fill: "#3A225D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.224 26.016C14.272 25.728 14.144 25.536 13.92 25.584C14.016 25.68 14.064 25.808 14.016 26L13.408 28.864C13.488 28.832 13.552 28.8 13.632 28.784L14.224 26.016Z",
    fill: "#3A225D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.936 27.36C26 27.344 26.064 27.344 26.144 27.328L26.752 24.752C26.688 24.768 26.608 24.768 26.544 24.784L25.936 27.36Z",
    fill: "#3A225D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M27.088 23.136C27.168 22.768 26.864 22.72 26.784 22.752C26.88 22.784 26.912 22.992 26.88 23.168L26.752 23.728C26.832 23.712 26.896 23.696 26.976 23.68L27.088 23.136Z",
    fill: "#3A225D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.24 24.72C13.264 24.096 13.984 23.232 13.808 21.984L13.584 22C13.632 22.432 13.68 23.68 12.24 24.72Z",
    fill: "#3A225D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M7.328 35.504C8.048 35.664 9.408 38.032 11.76 37.648C9.376 37.744 8.112 35.408 7.536 35.424L7.328 35.504Z",
    fill: "#3A225D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60799 26.416L8.28799 26.448C9.296 26.864 10.544 30.8 12.976 31.312C10.528 30.432 9.68 27.152 8.60799 26.416Z",
    fill: "#3A225D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26.048 33.408C24.688 32.96 23.536 33.216 23.216 33.312L23.152 33.52C23.616 33.376 24.608 33.152 26.048 33.408Z",
    fill: "#3A225D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M13.232 35.6C13.312 35.632 13.52 35.712 13.68 35.792L13.664 35.92C13.504 35.84 13.12 35.68 13.04 35.632L13.68 32.88C13.728 32.912 13.792 32.96 13.84 33.008L13.232 35.6Z",
    fill: "#3A225D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 29.472C16.496 29.472 16.48 29.472 16.464 29.472C16.576 29.568 16.656 29.712 16.608 29.92L15.216 35.888C15.28 35.824 15.36 35.776 15.44 35.744L16.832 29.824C16.848 29.728 16.848 29.648 16.8 29.584C16.72 29.504 16.592 29.472 16.512 29.472Z",
    fill: "#3A225D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.888 27.984L18.416 25.728C18.352 25.744 18.272 25.792 18.192 25.824L17.664 28.064C17.728 28.048 17.808 28.016 17.888 27.984Z",
    fill: "#3A225D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.032 32.624C14.128 32.704 14.224 32.8 14.336 32.912L14.384 32.736C14.32 32.688 14.272 32.624 14.208 32.576C14.144 32.576 14.096 32.592 14.032 32.624Z",
    fill: "#3A225D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.592 24.992C20.624 24.864 20.608 24.768 20.544 24.704C20.48 24.608 20.352 24.576 20.256 24.576C20.352 24.672 20.416 24.832 20.368 25.04L19.264 29.664C18.864 29.872 18.672 30.352 18.608 30.592C18.672 30.576 18.736 30.56 18.8 30.56C18.864 30.32 19.04 29.872 19.472 29.568L20.592 24.992Z",
    fill: "#3A225D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.576 34.336C26.912 33.808 27.472 32.816 27.728 32.096C27.536 31.712 27.2 31.136 26.96 30.864L26.784 30.992C26.992 31.216 27.36 31.808 27.52 32.144C27.28 32.832 26.784 33.968 26.576 34.336Z",
    fill: "#3A225D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M28.464 29.872C28.64 29.424 28.976 28.016 28.72 27.328L28.512 27.52C28.672 27.696 28.704 28.992 28.464 29.872Z",
    fill: "#3A225D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28.592 23.552L28.384 24.32C28.448 24.32 28.624 24.24 28.704 23.92L28.8 23.504C28.736 23.52 28.624 23.536 28.592 23.552Z",
    fill: "#3A225D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_876_11451",
    x1: -1.6712,
    y1: 29.9612,
    x2: 28.7717,
    y2: 17.0389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674847,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#F2C02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1463,
    stopColor: "#F3C535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#F5CD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2145,
    stopColor: "#F8D760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#FBE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2787,
    stopColor: "#FFF6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#FAE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5252,
    stopColor: "#F6CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6199,
    stopColor: "#F3C331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6748,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#F4C639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7618,
    stopColor: "#F8DA66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8405,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8583,
    stopColor: "#FCED92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#F9DC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9174,
    stopColor: "#F6CF4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9462,
    stopColor: "#F4C638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9741,
    stopColor: "#F2C12B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2BF27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_876_11451",
    x1: 12.0777,
    y1: 10.754,
    x2: 16.3373,
    y2: 9.16899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3A225D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#76658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3287,
    stopColor: "#B0A7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4068,
    stopColor: "#DBD6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F5F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#FBFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5887,
    stopColor: "#EFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#DBD6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6892,
    stopColor: "#BFB7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7417,
    stopColor: "#9B8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#6E5D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#3B235E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3A225D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_876_11451",
    x1: 13.4188,
    y1: 14.3585,
    x2: 17.6787,
    y2: 12.7735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3A225D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#76658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3287,
    stopColor: "#B0A7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4068,
    stopColor: "#DBD6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F5F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#FBFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5887,
    stopColor: "#EFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#DBD6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6892,
    stopColor: "#BFB7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7417,
    stopColor: "#9B8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#6E5D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#3B235E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3A225D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_876_11451",
    x1: 14.3104,
    y1: 16.7545,
    x2: 18.5702,
    y2: 15.1694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3A225D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236,
    stopColor: "#76658E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3287,
    stopColor: "#B0A7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4068,
    stopColor: "#DBD6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#F5F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#FBFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5887,
    stopColor: "#EFEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#DBD6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6892,
    stopColor: "#BFB7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7417,
    stopColor: "#9B8EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#6E5D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#3B235E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3A225D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_876_11451",
    x1: 6.42203,
    y1: 24.554,
    x2: 25.0275,
    y2: 16.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674847,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#F2C02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1463,
    stopColor: "#F3C535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#F5CD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2145,
    stopColor: "#F8D760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#FBE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2787,
    stopColor: "#FFF6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3597,
    stopColor: "#FAE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#F6CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4985,
    stopColor: "#F3C331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5337,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2BF27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_876_11451",
    x1: 10.6568,
    y1: 24.9333,
    x2: 24.4452,
    y2: 19.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674847,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963258,
    stopColor: "#F2C02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1215,
    stopColor: "#F3C535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    stopColor: "#F5CD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1683,
    stopColor: "#F8D760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1907,
    stopColor: "#FBE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2123,
    stopColor: "#FFF6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2771,
    stopColor: "#FAE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F6CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3888,
    stopColor: "#F3C331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5828,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9202,
    stopColor: "#F2BF27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_876_11451",
    x1: 0.246837,
    y1: 45.3836,
    x2: 23.3347,
    y2: 35.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674847,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#F2C02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1463,
    stopColor: "#F3C535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#F5CD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2145,
    stopColor: "#F8D760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#FBE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2787,
    stopColor: "#FFF6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    stopColor: "#FAE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#F6CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#F3C331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_876_11451",
    x1: 10.13,
    y1: 44.94,
    x2: 28.063,
    y2: 37.3279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674847,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#F2C02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1463,
    stopColor: "#F3C535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#F5CD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2145,
    stopColor: "#F8D760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#FBE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2787,
    stopColor: "#FFF6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3597,
    stopColor: "#FAE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#F6CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4985,
    stopColor: "#F3C331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5337,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7669,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2BF27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_876_11451",
    x1: 2.64321,
    y1: 34.4964,
    x2: 29.062,
    y2: 23.2823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674847,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1095,
    stopColor: "#F2C02A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1463,
    stopColor: "#F3C535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#F5CD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2145,
    stopColor: "#F8D760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    stopColor: "#FBE581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2787,
    stopColor: "#FFF6A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2822,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3692,
    stopColor: "#FAE27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4569,
    stopColor: "#F6CF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5249,
    stopColor: "#F3C331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5644,
    stopColor: "#F2BF27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6994,
    stopColor: "#FFF8AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9018,
    stopColor: "#F2BF27"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/partner1.9820adee735cb1fc08771f0fdabe9e18.svg";
export { ForwardRef as ReactComponent };